// extracted by mini-css-extract-plugin
module.exports = {"eventContainer":"TimelineEvent_eventContainer__nhC12","eventTitle":"TimelineEvent_eventTitle__armZ5"};